import React, { useRef } from "react";
import connect from "Shared/connect";
import * as styles from "./base.scss";
import Icon from "Shared/Icon";
import { setRightMenu } from "../action-creators";
const CloseButton = (prop) => {
    const btnRef = useRef(null);
    return (React.createElement("div", { className: styles.container },
        React.createElement("button", { className: styles.button, onClick: prop.closeRightMenu, ref: btnRef, tabIndex: prop.tabIndex },
            React.createElement(Icon, { name: "header-close", className: styles.icon }))));
};
export default connect((state) => ({
    mainMeny: state.mainMenu,
}), (dispatch) => ({
    closeRightMenu: () => dispatch(setRightMenu(false)),
}))(CloseButton);
